<template>
  <div class="trx-card-shimmer">
    <div>
      <div class="animate-pulse bg-gray-20 rounded" style="height: 80px; width: 80px" />
    </div>
    <div>
      <div class="animate-pulse bg-gray-20 rounded" style="height: 16px; width: 250px" />
      <div class="mt-16 animate-pulse bg-gray-20 rounded" style="height: 16px; width: 220px" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardShimmer',
};
</script>

<style lang="scss" scoped>
.trx-card-shimmer {
  padding: 12px;
  border: 1px solid #d6d6d6;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
